{
  "required": "This field is required",
  "email": "Enter a valid email address",
  "minLength": "Must be at least {{count}} characters",
  "maxLength": "Must be at most {{count}} characters",
  "passwordWeak": "Password is too weak",
  "passwordsMismatch": "Passwords do not match",
  "invalidNumber": "Value must be a number",
  "positiveNumber": "Value must be greater than zero",
  "invalidPhone": "Enter a valid phone number",
  "maxItems": "Must be at most {{count}} items"
}
